<template>
  <div class="seomain">
    <st-header
      :title="formData.id ? '编辑SKU' : '添加SKU'"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <!-- <div class="st-form-title">基本信息</div> -->
        <div class="st-form-group">

          <van-cell-group inset>
            <st-form-item key="category_id" label="产品类别" prop="category_id" :required="true">
              <st-select
                v-model="formData.category_id"
								:defText="formData.category_name"
                name="产品类别"
                placeholder="请选择产品类别"
                :options="$option['getCategorys']"
								:clearable="true"
              >
              </st-select>
            </st-form-item>
					
						
						<st-form-item key="brand" label="品牌" prop="brand" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.brand"
						    name="品牌"
						    label=""
						    placeholder="请填写品牌"
						  />
						</st-form-item>
						
						<st-form-item key="name" label="产品名称（描述)" prop="name">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.name"
						    name="产品名称（描述）"
						    label=""
						    placeholder="请填写产品名称（描述）"
						  />
						</st-form-item>
						
						<st-form-item key="unit" label="单位" prop="unit" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.unit"
						    name="单位"
						    label=""
						    placeholder="如: 条、个、块、台"
						  />
						</st-form-item>
						
						<st-form-item key="sku" label="SKU" prop="sku" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.sku"
						    name="SKU"
						    label=""
						    placeholder="请填写SKU"
						  />
						</st-form-item>
						
						<st-form-item key="productlabel" label="商品标签" prop="productlabel">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.productlabel"
						    name="商品标签"
						    label=""
						    placeholder="请填写商品标签"
						  />
						</st-form-item>
						
						<st-form-item key="weight" label="重量" prop="weight">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.weight"
						    name="重量"
						    label=""
						    placeholder="请填写重量"
						  />
						</st-form-item>
						
            <st-form-item key="productnote" label="商品备注" prop="productnote">
							<van-field
								class="st-form-item-input"
								v-model="formData.productnote"
								name="商品备注"
								label=""
								placeholder="请填写商品备注"
								type="textarea"
							/>
            </st-form-item>
						
						
						<st-form-item key="image" label="主图" prop="image">
						  <st-file-upload
						    v-model="formData['image']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="images" label="副图" prop="images">
						  <st-file-upload
						    v-model="formData['images']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="attachment" label="附件" prop="attachment">
						  <st-file-upload
						    v-model="formData['attachment']"
						  >
						  </st-file-upload>
						</st-form-item>
						
						<st-form-item key="manufacturercode" label="制造方编码" prop="manufacturercode">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.manufacturercode"
						    name="制造方编码"
						    label=""
						    placeholder="请填写制造方编码"
						  />
						</st-form-item>
						
						<st-form-item key="customscode" label="海关编码" prop="customscode">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.customscode"
						    name="海关编码"
						    label=""
						    placeholder="请填写海关编码"
						  />
						</st-form-item>
						
						<st-form-item key="placeoforigin" label="原产地" prop="placeoforigin">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.placeoforigin"
						    name="原产地"
						    label=""
						    placeholder="请填写原产地"
						  />
						</st-form-item>
						
						<st-form-item key="eancode" label="EAN编码" prop="eancode">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.eancode"
						    name="EAN编码"
						    label=""
						    placeholder="请填写EAN编码"
						  />
						</st-form-item>
						
						<st-form-item key="qty" label="装箱数量" prop="qty">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.qty"
						    name="装箱数量"
						    label=""
						    placeholder="请填写装箱数量"
						  />
						</st-form-item>
						
						<st-form-item key="fclweight" label="整箱重量" prop="fclweight">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.fclweight"
						    name="整箱重量"
						    label=""
						    placeholder="请填写整箱重量"
						  />
						</st-form-item>
						
						<st-form-item key="grossweightofgoods" label="商品毛重" prop="grossweightofgoods">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.grossweightofgoods"
						    name="商品毛重"
						    label=""
						    placeholder="请填写商品毛重"
						  />
						</st-form-item>
						
						<st-form-item key="netweightofgoods" label="商品净重" prop="netweightofgoods">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.netweightofgoods"
						    name="商品净重"
						    label=""
						    placeholder="请填写商品净重"
						  />
						</st-form-item>
						
						<st-form-item key="Productsize" label="商品尺寸(CM):" prop="Productsize">
							<div class="data-size">
								<van-field
									class="st-form-item-input"
									v-model="formData.Productsize_l"
									label=""
									placeholder="长"
								/>
								<span class="span-x">X</span>
								<van-field
									class="st-form-item-input"
									v-model="formData.Productsize_w"
									label=""
									placeholder="宽"
								/>
								<span class="span-x">X</span>
								<van-field
									class="st-form-item-input"
									v-model="formData.Productsize_h"
									label=""
									placeholder="高"
								/>
							</div>
						</st-form-item>
						
						<st-form-item key="packagesize" label="包装尺寸(CM):" prop="packagesize">
							<div class="data-size">
								<van-field
									class="st-form-item-input"
									v-model="formData.packagesize_l"
									label=""
									placeholder="长"
								/>
								<span class="span-x">X</span>
								<van-field
									class="st-form-item-input"
									v-model="formData.packagesize_w"
									label=""
									placeholder="宽"
								/>
								<span class="span-x">X</span>
								<van-field
									class="st-form-item-input"
									v-model="formData.packagesize_h"
									label=""
									placeholder="高"
								/>
							</div>
						</st-form-item>
						
						<st-form-item key="fclvolume" label="整箱体积(CM):" prop="fclvolume">
							<div class="data-size">
								<van-field
									class="st-form-item-input"
									v-model="formData.fclvolume_l"
									label=""
									placeholder="长"
								/>
								<span class="span-x">X</span>
								<van-field
									class="st-form-item-input"
									v-model="formData.fclvolume_w"
									label=""
									placeholder="宽"
								/>
								<span class="span-x">X</span>
								<van-field
									class="st-form-item-input"
									v-model="formData.fclvolume_h"
									label=""
									placeholder="高"
								/>
							</div>
						</st-form-item>
						
						<st-form-item key="remark" label="其他属性" prop="remark">
							<van-field
								class="st-form-item-input"
								v-model="formData.otherattributes"
								name="其他属性"
								label=""
								placeholder="请填写其他属性"
								type="textarea"
							/>
						</st-form-item>
          </van-cell-group>
        </div>
        
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				brand: '',
				modeljson: [],
				image: [],
				images: [],
				attachment: [],
      }, 
      loading: false,
      actField: '',
      actOptions: [],
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
  mounted() {},

  methods: {
    init() {
			let query = this.$route.query;
			if (query.id) this.formData.id = query.id;
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.skueditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					this.formData = data;
				}).catch((err) => {
					window.history.go(-1);
					console.log('sku/edit', err);
				});
			} else {}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			formData['image'] = formData['image'].map((item) => { return item.url; }).join(',');
			formData['images'] = formData['images'].map((item) => { return item.url; }).join(',');
			formData['attachment'] = formData['attachment'].map((item) => { return item.url; }).join(',');
			if (this.formData.id) {
				this.updateData(formData);
			} else {
				this.addData(formData);
			}
      
    },
		
		addData(formData) {
			this.$post(this.$api.skuadd, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '创建异常');
			  } else {
			    this.$toast.success("创建成功");
			    this.$router.replace(`/sku/list`);
			  }
			});
		},
		updateData(formData) {
			this.$post(this.$api.skuedit, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '编辑异常');
			  } else {
			    this.$toast.success("编辑成功");
			    this.$router.replace(`/sku/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

		.data-size {
			display: flex;
			.span-x {
				line-height: 44px;
				padding: 0px 2px;
			}
		}
  }

}

</style>
